import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./features";
import { unauthorizedMiddleware } from "./middleware";

// Create store only once, reuse it on HMR updates
let store = window.__REDUX_STORE__;

if (!store) {
  store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat([unauthorizedMiddleware]),
  });

  // Make store available globally for callApi.js to avoid circular dependencies
  if (typeof window !== 'undefined') {
    window.__REDUX_STORE__ = store;
  }
  
  // Enable HMR for Redux store
  if (module.hot) {
    module.hot.accept('./features', () => {
      // Replace the store's reducer with the new root reducer
      store.replaceReducer(rootReducer);
    });
  }
}

export default store;

